import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import Coupon from '../Coupon2';

interface RewardsSwiperProps {
    list: any[];
    swiperKey: string; // 用于区分不同Swiper的唯一标识，如 'discount'、'product'、'giftcard'
    state: any;
    isLogin: boolean;
    ecoState: any;
    setCurrNotes: (notes: any) => void;
    openConfirmModal: (rule: any) => void;
    customColor?: Record<string, string | undefined>;
    hideAmount?: boolean;
}

const RewardsSwiper = ({ list, swiperKey, state, isLogin, ecoState, setCurrNotes, openConfirmModal, customColor, hideAmount = false }: RewardsSwiperProps) => {
    if (!list || list.length === 0) return null;

    return (
        <div className="rule-list-wrap">
            <Swiper
                modules={[Navigation, Pagination]}
                slidesPerView={4}
                spaceBetween={24}
                navigation={{
                    prevEl: `.${swiperKey}-swiper-button-prev`,
                    nextEl: `.${swiperKey}-swiper-button-next`,
                }}
                pagination={{
                    clickable: true,
                    el: `.${swiperKey}-swiper-pagination`,
                }}
                breakpoints={{
                    320: { slidesPerView: 'auto', spaceBetween: 10 },
                    768: { slidesPerView: 'auto', spaceBetween: 10 },
                    1200: { slidesPerView: 'auto' as any, spaceBetween: 24 },
                }}
                className="rewards-swiper"
            >
                {list.map((rule: any) => (
                    <SwiperSlide key={rule?.ruleId}>
                        <Coupon
                            disabledBtn={
                                state.inBlackList ||
                                (isLogin && Number(rule?.points) > ecoState.rewardUserInfo?.points) ||
                                (rule?.ruleType !== 'COUPONS' && rule?.stock === 0)
                            }
                            showstock={rule?.ruleType !== 'COUPONS' && rule?.stockPicEnable}
                            className="rule-item"
                            coupon={rule}
                            onViewsRules={setCurrNotes}
                            onReedem={openConfirmModal}
                            showCountDown
                            customColor={customColor}
                            hideAmount={hideAmount}
                        />
                    </SwiperSlide>
                ))}

                {/* 左右箭头 */}
                <div className={`swiper-button-prev ${swiperKey}-swiper-button-prev`}></div>
                <div className={`swiper-button-next ${swiperKey}-swiper-button-next`}></div>

                {/* 分页指示点 */}
                <div className={`swiper-pagination ${swiperKey}-swiper-pagination`}></div>
            </Swiper>
        </div>
    );
};

export default RewardsSwiper;
